'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.setVideos = exports.updateVideos = undefined;

var _functional = require('../utils/functional');

var _videos = require('../utils/videos');

var videos = [];
var isLoading = false;

var updateVideos = exports.updateVideos = function updateVideos() {
  videos = (0, _functional.getElements)('.' + _videos.classes.LOADER);
};

var setVideos = exports.setVideos = function setVideos() {
  isLoading = true;

  videos.forEach(function (video) {
    // Check if video is inside viewport
    if (!video.lazyloaded && video.getBoundingClientRect().top < (0, _functional.getViewportSize)().vh) {
      (0, _videos.loadVideo)(video, { loadingClass: _videos.classes.LOADER });
      video.lazyloaded = true;
    }
  });

  // Once the videos have been loaded remove them from the list
  videos = videos.filter(function (image) {
    return !image.lazyloaded;
  });

  isLoading = false;
};

var init = exports.init = function init() {
  updateVideos();
  setVideos();

  document.addEventListener('scroll', function () {
    // Avoids setVideos from running multiple times on scroll
    if (isLoading) return false;
    setVideos();
  });
};